import React from 'react';
import { Form, Input, Radio, Select, Typography } from 'antd';
import { CloudOutlined } from '@ant-design/icons';
import DdnHeField from '../components/DdnHeField';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { useFormPath } from './index';

const { Text } = Typography;

export default (formPlugin, namespace) => {

    return {
        Renderer: (props) => {
            const { listFieldProps, buildName } = useFormPath()

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }

            if ((props.isPreviewMode || props.readOnly) && !props.data.fieldKey) {
                return null
            }

            const { data } = props
            const reducedWidth = data.reduced ? "48%" : "100%"
            const finalName = "[HAZKARA]_" + data.fieldKey

            // Helper local pour produire le name complet d'un sous-champ
            const subName = (field) => buildName([finalName, field])

            return (
                <div>

                    <Form.Item
                        {...(listFieldProps || {})}
                        label={t`Civilité` + " :"}
                        name={subName("homme")}
                        rules={[{
                            required: data.required,
                            message: t`Ce champ est obligatoire`
                        }]}
                    >
                        <Select size="large" placeholder={t`Civilité`}>
                            <Select.Option value={true}><Trans>Monsieur</Trans></Select.Option>
                            <Select.Option value={false}><Trans>Madame</Trans></Select.Option>
                        </Select>
                    </Form.Item>

                    <Form.Item noStyle shouldUpdate={(prev, next) => prev.identity !== next.identity}>
                        {(_form) => {
                            const identity = _form.getFieldValue("identity")
                            const homme = _form.getFieldValue(subName("homme"))

                            let label = t`Il/elle est`
                            if (homme === true) label = t`Il est`
                            if (homme === false) label = t`Elle est`

                            const options = formPlugin.RELATIONS_OPTIONS
                            const _name = identity?.nom && identity?.prenom ? `${identity.prenom} ${identity.nom}` : null

                            return (
                                <Form.Item
                                    {...(listFieldProps || {})}
                                    label={label + " :"}
                                    name={subName("_relation")}
                                    rules={[{
                                        required: data.required,
                                        message: t`Ce champ est obligatoire`
                                    }]}
                                >
                                    <Select size="large" placeholder={label}>
                                        {options.map(i => {
                                            let _label = i.labelH + " / " + i.labelF
                                            if (homme === true) _label = i.labelH
                                            if (homme === false) _label = i.labelF

                                            return (
                                                <Select.Option key={i.value} value={i.value}>
                                                    {_name ? (
                                                            <Trans context="form.family-relationship" comment="Selected family relationship of the person being entered to the named contact; the name is a literal proper name. Translate as a complete phrase and reorder if needed.">{_label} de <Text strong>{_name}</Text></Trans>
                                                        ) : _label}
                                                </Select.Option>
                                            )
                                        })}
                                        <Select.Option key="OTHER" value="OTHER"><Trans>Autre</Trans></Select.Option>
                                    </Select>
                                </Form.Item>
                            )
                        }}
                    </Form.Item>

                    <div style={{ display: data.reduced ? "flex" : "block", justifyContent: "space-between" }}>
                        <Form.Item
                            {...(listFieldProps || {})}
                            label={(data.labelPrenom || t`Prénom`) + " :"}
                            name={subName("prenom")}
                            rules={[{ required: data.required, message: t`Ce champ est obligatoire` }]}
                            style={{ width: reducedWidth }}
                        >
                            <Input type="text" placeholder={data.labelPrenom || t`Prénom`} />
                        </Form.Item>

                        <Form.Item
                            {...(listFieldProps || {})}
                            label={(data.labelNom || t`Nom`) + " :"}
                            name={subName("nom")}
                            rules={[{ required: data.required, message: t`Ce champ est obligatoire` }]}
                            style={{ width: reducedWidth }}
                        >
                            <Input type="text" placeholder={data.labelNom || t`Nom`} />
                        </Form.Item>
                    </div>

                    <div style={{ display: data.reduced ? "flex" : "block", justifyContent: "space-between" }}>
                        <Form.Item
                            {...(listFieldProps || {})}
                            label={t`Prénom Hébraïque` + " :"}
                            name={subName("prenomHE")}
                            rules={[{ required: data.required, message: t`Ce champ est obligatoire` }]}
                            style={{ width: reducedWidth }}
                        >
                            <Input type="text" placeholder={t`Prénom Hébraïque`} />
                        </Form.Item>

                        <Form.Item
                            {...(listFieldProps || {})}
                            label={t`Lieu de l'enterrement` + " :"}
                            name={subName("deceasedLocation")}
                            style={{ width: reducedWidth }}
                        >
                            <Input type="text" placeholder={t`Lieu de l'enterrement`} />
                        </Form.Item>
                    </div>

                    <div style={{ display: data.reduced ? "flex" : "block", justifyContent: "space-between" }}>
                        <Form.Item
                            {...(listFieldProps || {})}
                            label={t`Date du Décès` + " :"}
                            name={subName("deceasedDate")}
                            rules={[{ required: data.required, message: t`Ce champ est obligatoire` }]}
                            style={{ width: reducedWidth }}
                        >
                            <DdnHeField placeholder={t`Date du Décès`} />
                        </Form.Item>

                        <Form.Item
                            {...(listFieldProps || {})}
                            label={t`Heure du Décès` + " :"}
                            name={subName("deceasedHour")}
                            rules={[{ required: data.required, message: t`Ce champ est obligatoire` }]}
                            style={{ width: reducedWidth }}
                        >
                            <Radio.Group>
                                <Radio.Button value={false}><Trans>Pendant la journée</Trans></Radio.Button>
                                <Radio.Button value={true}><Trans>Pendant la nuit</Trans></Radio.Button>
                            </Radio.Group>
                        </Form.Item>
                    </div>

                    <div style={{ display: data.reduced ? "flex" : "block", justifyContent: "space-between" }}>
                        <Form.Item
                            {...(listFieldProps || {})}
                            label={t`Prénom Hébraïque du Père` + " :"}
                            name={subName("deceasedPere")}
                            rules={[{ required: data.required, message: t`Ce champ est obligatoire` }]}
                            style={{ width: reducedWidth }}
                        >
                            <Input type="text" placeholder={t`Prénom Hébraïque du Père`} />
                        </Form.Item>

                        <Form.Item
                            {...(listFieldProps || {})}
                            label={t`Prénom Hébraïque de la Mère` + " :"}
                            name={subName("deceasedMere")}
                            rules={[{ required: data.required, message: t`Ce champ est obligatoire` }]}
                            style={{ width: reducedWidth }}
                        >
                            <Input type="text" placeholder={t`Prénom Hébraïque de la Mère`} />
                        </Form.Item>
                    </div>
                </div>
            )
        },
        namespace: namespace,
        id: 'form-hazkara' + namespace,
        title: t`Champ Hazkara`,
        description: t`Élément de formulaire utilisable.`,
        icon: <CloudOutlined />,
        iconColor: "#F39C12",
        version: 1,
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    required: {
                        type: 'boolean',
                        uniforms: { label: t`Obligatoire` }
                    },
                    reduced: {
                        type: 'boolean',
                        uniforms: { label: t`Formulaire Réduit` }
                    },
                    fieldKey: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Identifiant`,
                            placeholder: t`Identifiant du Champ`
                        }
                    },
                }
            },
        },
    }
}
